import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import writeExcelFile from 'write-excel-file/browser';

const EXCEL_EXTENSION = '.xlsx';
const EXCEL_DATE_FORMAT = 'dd/mm/yyyy';

@Injectable()
export class ExcelService {

  constructor() { }

  public async exportAsExcelFile(json: any[], excelFileName: string): Promise<void> {
    const rows = Array.isArray(json) ? json : [];
    const headers = Array.from(
      new Set(rows.flatMap((row) => row && typeof row === 'object' ? Object.keys(row) : [])),
    );
    // `write-excel-file` only accepts plain objects in its object + columns
    // overload. Some API mappers return model class instances, such as
    // `DataCombustible`, so write the normalized values as sheet rows instead.
    const sheetData = headers.length > 0
      ? [
          headers,
          ...rows.map((row) => headers.map((header) => row?.[header] ?? null)),
        ]
      : [[]];

    const excelBlob = await writeExcelFile(sheetData, {
      sheet: 'data',
      dateFormat: EXCEL_DATE_FORMAT,
    }).toBlob();

    this.saveAsExcelFile(excelBlob, excelFileName);
  }

  private saveAsExcelFile(data: Blob, fileName: string): void {
    FileSaver.saveAs(data, fileName + '_exported' + EXCEL_EXTENSION);
  }

}
